export default __webpack_public_path__ + "static/media/15.3d523b61.png";